import { ENTER_DISTANCE } from "./constants";
import { TooltipPosition } from "./types";

// The bubble slides in from the trigger's side.
export const computeEnterOffset = (side: TooltipPosition): string => {
  switch (side) {
    case "top":
      return `translateY(${ENTER_DISTANCE}px)`;
    case "bottom":
      return `translateY(-${ENTER_DISTANCE}px)`;
    case "left":
      return `translateX(${ENTER_DISTANCE}px)`;
    case "right":
      return `translateX(-${ENTER_DISTANCE}px)`;
  }
};

// floating-ui returns placements such as "top-start".
export const getSide = (placement: string): TooltipPosition =>
  placement.split("-")[0] as TooltipPosition;
